import { VegobjekterStatisticsResponse } from '../responses';
import { AllVegnettStatisticsResponseGruppert } from '../responses/VegnettStatisticsResponse';
import {
    AllVegobjekterStatisticsResponseGruppert,
    VegobjekterStatisticsByKategoriResponseGruppert,
    VegobjekterStatisticsResponseGruppert,
} from '../responses/VegobjekterStatisticsResponseGruppert';

export function transformVegnettStatisticsGruppert(data: unknown): AllVegnettStatisticsResponseGruppert[] {
    if (!data) return null;

    return (data as AllVegnettStatisticsResponseGruppert[]).map(
        vegnett =>
            new AllVegnettStatisticsResponseGruppert(
                vegnett['antall'],
                vegnett['vegkategori'],
                vegnett['fylke']
            )
    );
}

export function transformVegobjekterStatistics(data: unknown): VegobjekterStatisticsResponse {
    if (data && data['antall'] !== undefined)
        return new VegobjekterStatisticsResponse(data['antall'], data['lengde']);
    else return null;
}

export function transformVegobjekterStatisticsGruppert(
    data: unknown
): VegobjekterStatisticsResponseGruppert[] {
    if (!data) return null;

    return (data as VegobjekterStatisticsResponseGruppert[]).map(
        vegobjekt =>
            new VegobjekterStatisticsResponseGruppert(
                vegobjekt['antall'],
                vegobjekt['lengde'],
                vegobjekt['fylke']
            )
    );
}

export function transformVegobjekterStatisticsByKategoriGruppert(
    data: unknown
): VegobjekterStatisticsByKategoriResponseGruppert[] {
    if (!data) return null;

    return (data as VegobjekterStatisticsByKategoriResponseGruppert[]).map(
        vegobjekt =>
            new VegobjekterStatisticsByKategoriResponseGruppert(
                vegobjekt['antall'],
                vegobjekt['lengde'],
                vegobjekt['vegkategori']
            )
    );
}

export function transformAllVegobjekterStatisticsGruppert(
    data: unknown
): AllVegobjekterStatisticsResponseGruppert[] {
    if (!data) return null;

    return (data as AllVegobjekterStatisticsResponseGruppert[]).map(
        vegobjekt =>
            new AllVegobjekterStatisticsResponseGruppert(
                vegobjekt['antall'],
                vegobjekt['lengde'],
                vegobjekt['vegkategori'],
                vegobjekt['fylke'],
                vegobjekt['kommune']
            )
    );
}
